<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">New Group</span>
        </v-card-title>
        <v-card-text>
          <v-row no-gutters>
            <v-col sm="12" md="6" class="pa-1">
              <v-text-field
                label="name*"
                placeholder="Name..."
                outlined
                :rules="[
                    () => min3 || 'This field must contain at least 3 characters.',
                ]"
                v-model="name"
                required
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="cancel">Close</v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="save"
            :disabled="!min3"
            :loading="isLoading"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isLoading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    dialog: { type: Boolean, required: true },
    isLoading: { type: Boolean, required: true }
  },
  data() {
    return {
      name: ""
    };
  },
  computed: {
    min3() {
      return this.name.length >= 3;
    }
  },
  methods: {
    reset() {
      this.name = "";
    },
    cancel() {
      this.$emit("cancel");
      this.reset();
    },
    save() {
      this.$emit("save", this.name);
    }
  }
};
</script>